import { render } from "./DynamicReport.vue?vue&type=template&id=e1fb6bae&scoped=true"
import script from "./DynamicReport.vue?vue&type=script&lang=ts"
export * from "./DynamicReport.vue?vue&type=script&lang=ts"

import "./DynamicReport.vue?vue&type=style&index=0&id=e1fb6bae&lang=scss&scoped=true"
import "./DynamicReport.vue?vue&type=style&index=1&id=e1fb6bae&lang=scss"
script.render = render
script.__scopeId = "data-v-e1fb6bae"

export default script